// ─── Coffee finder quiz popup (sections/custom-quiz-popup.liquid) ───
// Three questions -> email -> match on screen with the welcome code.
// - Email: Klaviyo client subscriptions API, list from the section config (Newsletter List 2026),
//   which starts the welcome series with the code. Answers and the match go on the profile.
// - Opens after the configured delay, only for people Klaviyo does not know yet, who have not
//   signed up or closed it recently (localStorage), and not on excluded pages. Links to
//   #coffee-quiz open it any time.
// - Live product data (link, price, photo, availability, notes) comes from the section's JSON.
//   Static copy below (names, roast labels, descriptions copied from the product pages 20 Oct,
//   label colours) and the match table (Mira 28 Oct).
(function () {
  if (window.__ifQuiz) return;
  window.__ifQuiz = true;

  var root = document.querySelector('[data-if-quiz]');
  if (!root) return;

  var cfg, live;
  try {
    cfg = JSON.parse(root.querySelector('[data-if-quiz-config]').textContent);
    live = JSON.parse(root.querySelector('[data-if-quiz-products]').textContent);
  } catch (err) {
    console.error('[coffee quiz] section data unreadable, quiz off', err);
    return;
  }

  var COPY = {
    "71-irving-house-blend": {
      "name": "71 House Medium Roast",
      "label": "Medium roast · Blend",
      "desc": "Named for our flagship cafe at 71 Irving Place in Gramercy Park, our house coffee is roasted to be perfectly sweet and smooth.",
      "color": "#0094c8"
    },
    "highline-light-roast": {
      "name": "Highline Light Roast",
      "label": "Light roast · Blend",
      "desc": "Our light roast offering raises the bar for a bright, delicate cup with sweet and tart notes. This coffee is certified Organic by Natural Food Certifiers.",
      "color": "#f491a3"
    },
    "gotham-dark-roast": {
      "name": "Gotham Dark Roast",
      "label": "Dark roast · Blend",
      "desc": "The just-right caramelization of sugars in our house dark roast delivers a perfect balance of flavors. This results in a deliciously deep, smoky coffee for all dark roast lovers.",
      "color": "#758592"
    },
    "blackstrap-espresso": {
      "name": "Blackstrap Espresso",
      "label": "Medium-dark roast · Blend",
      "desc": "Blackstrap Espresso is a versatile medium-dark roast coffee crafted for both espresso and drip brewing. Expect a full-bodied cup with balanced sweetness and flavor notes of chocolate and orange that tastes great on its own or paired with milk.",
      "color": "#ff5b36"
    },
    "sumatra-super-dark-1": {
      "name": "South Street Super Dark",
      "label": "Our darkest roast · Blend",
      "desc": "We're excited to deliver you our version of a true French roast coffee! Our darkest roast offers smoky, intense flavor that pairs perfectly with a splash of milk and a lil sugar",
      "color": "#4c2f48"
    },
    "decaf-blackstrap": {
      "name": "Decaf Blackstrap",
      "label": "Decaf · Medium roast · Blend",
      "desc": "Our house decaf is crafted from Mountain Water Process decaffeinated coffees for a balanced, sweet blend with substance that shines on both drip and espresso.",
      "color": "#b7dbd3"
    },
    "santa-isabel-guatemala-organic": {
      "name": "Santa Isabel, Guatemala",
      "label": "Single origin · Santa Rosa, Guatemala · Washed",
      "desc": "This coffee stands out with its excellent balance and structure produced through innovative biodynamic & organic farming by the Keller family in Santa Rosa, Guatemala. Roasted by Irving Farm in New York and certified organic by Natural Food Certifiers.",
      "color": "#1a1a1a"
    },
    "monserrate-br-colombia": {
      "name": "Monserrate, Colombia",
      "label": "Single origin · Huila, Colombia · Washed",
      "desc": "This smooth, balanced coffee comes from the Monserrate Cooperative in Huila, Colombia. By offering a fixed price on their coffee, we’ve helped the community to invest in long term projects. Since 2017, Irving Farm has contributed over $30,000 which has funded wastewater treatment infrastructure, solar coffee drying infrastructure, and emergency landslide relief.",
      "color": "#1a1a1a"
    },
    "minas-gerais-brazil": {
      "name": "Minas Gerais, Brazil",
      "label": "Single origin · Campo das Vertentes, Brazil · Natural",
      "desc": "This single origin coffee is produced by the SanCoffee cooperative in the Brazilian State of Minas Gerais. The group is focused on sustainable coffee production, and achieved B corps certification in 2019. Its smooth, classic, mellow flavors are the result of a natural drying process, with the classic chocolate and nut tasting notes that are sought for in Brazilian coffees.",
      "color": "#1a1a1a"
    },
    "lamari-papua-new-guinea": {
      "name": "Lamari, Papua New Guinea",
      "label": "Single origin · Eastern Highlands, Papua New Guinea · Washed",
      "desc": "Lamari is produced by indigenous smallholder farmers around the Lamari river valley in Papua New Guinea. Their harvest is wet milled, washed, and dried on raised beds in small batches. The unique profile of this sweet, rich coffee comes from the terroir of the eastern highlands with careful picking, processing and milling.",
      "color": "#1a1a1a"
    },
    "ethiopia-mulish": {
      "name": "Ethiopia Mulish",
      "label": "Single origin · Guji, Ethiopia · Natural",
      "desc": "Coffees from Guji have become renowned for their bright and juicy flavor profiles. In 2014, Faisal Abdush established the Mulish washing station to process and dry coffee from local producers. We hope you enjoy the fruity flavors and full body of this coffee.",
      "color": "#1a1a1a"
    }
  };

  // flavor x type -> [match, also try]. Mira 28 Oct: bright blend Highline only, bright single origin
  // Mulish or Monserrate, sweet blend 71 or Blackstrap, sweet single origin Santa Isabel or Lamari,
  // dark single origin Minas, decaf only Decaf Blackstrap.
  var MAP = {
    bright: { blend: ['highline-light-roast'], single: ['ethiopia-mulish', 'monserrate-br-colombia'] },
    sweet: { blend: ['71-irving-house-blend', 'blackstrap-espresso'], single: ['santa-isabel-guatemala-organic', 'lamari-papua-new-guinea'] },
    choc: { blend: ['blackstrap-espresso', '71-irving-house-blend'], single: ['minas-gerais-brazil', 'monserrate-br-colombia'] },
    dark: { blend: ['gotham-dark-roast', 'sumatra-super-dark-1'], single: ['minas-gerais-brazil', 'lamari-papua-new-guinea'] }
  };
  function candidates(st) {
    if (st.type === 'decaf') return ['decaf-blackstrap'];
    // South Street's own copy: "pairs perfectly with a splash of milk"
    if (st.flavor === 'dark' && st.type === 'blend' && st.milk === 'milk') return ['sumatra-super-dark-1', 'gotham-dark-roast'];
    return MAP[st.flavor][st.type];
  }
  // Sold-out or missing coffees drop out; the next candidate moves up.
  function pick(st) {
    return candidates(st).filter(function (h) {
      if (!live[h]) console.error('[coffee quiz] product missing in the store: ' + h);
      return live[h] && live[h].available && COPY[h];
    });
  }

  // ── storage (per-visitor convenience only; private mode just means it may show again) ──
  var KEY = 'ifCoffeeQuiz';
  function readState() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function writeState(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* storage blocked: popup may show again next visit */ } }

  var backdrop = root.querySelector('[data-ifq-backdrop]');
  var modal = root.querySelector('[data-ifq-modal]');
  var progress = root.querySelector('[data-ifq-progress]');
  var steps = {};
  root.querySelectorAll('[data-ifq-step]').forEach(function (s) { steps[s.getAttribute('data-ifq-step')] = s; });
  var current = 0;
  var history = [];
  var state = {};
  var lastFocus = null;
  var isOpen = false;

  function focusables() {
    var list = [root.querySelector('[data-ifq-close].ifq__x')];
    steps[current].querySelectorAll('button, a[href], input').forEach(function (el) {
      if (!el.hidden && !el.closest('[hidden]') && !el.disabled) list.push(el);
    });
    return list;
  }

  function go(step, back) {
    var from = steps[current], to = steps[step];
    if (from !== to) {
      from.hidden = true;
      from.classList.remove('is-active', 'is-back');
      if (!back) history.push(current);
    }
    to.hidden = false;
    to.classList.toggle('is-back', !!back);
    to.classList.remove('is-active');
    void to.offsetWidth;
    to.classList.add('is-active');
    current = step;
    progress.style.width = (step <= 0 ? 0 : step >= 5 ? 100 : Math.round(step / 4 * 100)) + '%';
    modal.classList.toggle('is-hero', step === 0);
    modal.setAttribute('aria-labelledby', 'ifq-title-' + step);
    var target = step === 4 ? to.querySelector('input') : to.querySelector('[tabindex="-1"]');
    if (target) target.focus({ preventScroll: true });
  }

  function open() {
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;
    var hero = root.querySelector('[data-ifq-hero]');
    if (hero && !hero.style.backgroundImage) hero.style.backgroundImage = 'url("' + hero.getAttribute('data-bg') + '")';
    state = {};
    history = [];
    root.querySelectorAll('.ifq__opt').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
    Object.keys(steps).forEach(function (k) { steps[k].hidden = true; steps[k].classList.remove('is-active', 'is-back'); });
    current = 0;
    root.hidden = false;
    document.body.classList.add('ifq-lock');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    go(0);
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    var st = readState();
    if (!st || st.state !== 'done') writeState({ state: 'closed', at: Date.now() });
    root.classList.remove('is-open');
    document.body.classList.remove('ifq-lock');
    setTimeout(function () { root.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }

  // ── events ──
  root.addEventListener('click', function (evt) {
    var t = evt.target;
    if (t === backdrop) return close();
    if (t.closest('[data-ifq-close]')) return close();
    if (t.closest('[data-ifq-start]')) return go(1);
    if (t.closest('[data-ifq-back]')) return go(history.pop() || 0, true);
    var opt = t.closest('.ifq__opt');
    if (opt) {
      opt.parentNode.querySelectorAll('.ifq__opt').forEach(function (o) { o.setAttribute('aria-pressed', String(o === opt)); });
      state[opt.getAttribute('data-q')] = opt.getAttribute('data-val');
      var next = { flavor: 2, type: 3, milk: 4 }[opt.getAttribute('data-q')];
      setTimeout(function () { go(next); }, 260);
      return;
    }
    var copy = t.closest('[data-ifq-copy]');
    if (copy) return copyCode(copy);
  });

  root.addEventListener('keydown', function (evt) {
    if (!isOpen) return;
    if (evt.key === 'Escape') { evt.preventDefault(); return close(); }
    if (evt.key !== 'Tab') return;
    var f = focusables();
    var first = f[0], last = f[f.length - 1];
    if (evt.shiftKey && (document.activeElement === first || !modal.contains(document.activeElement))) { evt.preventDefault(); last.focus(); }
    else if (!evt.shiftKey && document.activeElement === last) { evt.preventDefault(); first.focus(); }
  });

  var form = root.querySelector('[data-ifq-form]');
  var input = form.querySelector('input');
  var err = root.querySelector('[data-ifq-err]');
  var submit = root.querySelector('[data-ifq-submit]');
  form.addEventListener('submit', function (evt) {
    evt.preventDefault();
    var email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      err.textContent = cfg.errorEmail;
      input.setAttribute('aria-invalid', 'true');
      input.focus();
      return;
    }
    input.removeAttribute('aria-invalid');
    err.textContent = '';
    var ids = pick(state);
    submit.setAttribute('aria-busy', 'true');
    submit.disabled = true;
    subscribe(email, ids)
      .then(function () {
        writeState({ state: 'done', at: Date.now() });
        try { if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email: email }); } catch (e) { console.error('[coffee quiz] klaviyo.identify', e); }
        buildResult(ids);
        go(5);
      })
      .catch(function (e) {
        console.error('[coffee quiz] sign-up failed', e);
        err.textContent = cfg.errorSubmit;
      })
      .then(function () { submit.removeAttribute('aria-busy'); submit.disabled = false; });
  });

  function subscribe(email, ids) {
    var c = COPY[ids[0]];
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: cfg.source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                properties: {
                  'Coffee quiz flavor': state.flavor,
                  'Coffee quiz type': state.type,
                  'Coffee quiz milk': state.milk,
                  'Coffee quiz match': c ? c.name : '',
                  'Coffee quiz match handle': ids[0] || '',
                  'Coffee quiz also try': ids[1] && COPY[ids[1]] ? COPY[ids[1]].name : ''
                }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: cfg.listId } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-10-15' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error('Klaviyo ' + r.status + ' ' + t.slice(0, 300)); });
    });
  }

  function buildResult(ids) {
    var main = ids[0], alt = ids[1];
    var c = COPY[main], l = live[main];
    var stepEl = steps[5];
    if (!c) {
      // Every candidate sold out: no match to show, send them to all coffee.
      stepEl.querySelector('[data-ifq-r-name]').textContent = 'All our coffee';
      stepEl.querySelector('[data-ifq-r-label]').textContent = '';
      stepEl.querySelector('[data-ifq-r-notes]').textContent = '';
      stepEl.querySelector('[data-ifq-r-blurb]').textContent = '';
      stepEl.querySelector('[data-ifq-r-bag]').hidden = true;
      stepEl.querySelector('[data-ifq-also]').hidden = true;
      var all = stepEl.querySelector('[data-ifq-shop]');
      all.textContent = 'Shop all coffee';
      all.href = '/collections/coffee';
      return;
    }
    root.style.setProperty('--ifq-accent', c.color);
    root.style.setProperty('--ifq-tint', 'color-mix(in srgb, ' + c.color + ' 14%, #ffffff)');
    var bag = stepEl.querySelector('[data-ifq-r-bag]');
    bag.hidden = !l.img;
    bag.src = l.img;
    bag.alt = c.name + ' coffee bag';
    stepEl.querySelector('[data-ifq-r-name]').textContent = c.name;
    stepEl.querySelector('[data-ifq-r-label]').textContent = c.label;
    stepEl.querySelector('[data-ifq-r-notes]').textContent = l.notes;
    stepEl.querySelector('[data-ifq-r-blurb]').textContent = c.desc;
    var also = stepEl.querySelector('[data-ifq-also]');
    also.hidden = !alt;
    if (alt) {
      var ai = also.querySelector('[data-ifq-a-img]');
      ai.src = live[alt].img;
      ai.alt = '';
      also.querySelector('[data-ifq-a-name]').textContent = COPY[alt].name;
      also.querySelector('[data-ifq-a-notes]').textContent = live[alt].notes;
      also.href = live[alt].url;
    }
    var shop = stepEl.querySelector('[data-ifq-shop]');
    shop.textContent = cfg.shopLabel.replace('{name}', c.name).replace('{price}', l.price);
    shop.href = l.url;
  }

  function copyCode(btn) {
    var code = root.querySelector('[data-ifq-code]').textContent.trim();
    var status = root.querySelector('[data-ifq-copy-status]');
    var label = btn.textContent;
    var done = function () {
      btn.textContent = btn.getAttribute('data-copied');
      status.textContent = btn.getAttribute('data-copied') + ': ' + code;
      setTimeout(function () { btn.textContent = label; }, 1600);
    };
    var select = function () {
      var r = document.createRange();
      r.selectNodeContents(root.querySelector('[data-ifq-code]'));
      var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, select);
    else select();
  }

  // ── when to open ──
  document.addEventListener('click', function (evt) {
    var a = evt.target.closest && evt.target.closest('a[href$="#coffee-quiz"], [data-open-coffee-quiz]');
    if (!a) return;
    evt.preventDefault();
    open();
  });
  if (location.hash === '#coffee-quiz') open();

  if (cfg.designMode) {
    document.addEventListener('shopify:section:select', function (e) { if (root.closest('[id*="' + e.detail.sectionId + '"]')) open(); });
    document.addEventListener('shopify:section:deselect', function (e) { if (root.closest('[id*="' + e.detail.sectionId + '"]')) close(); });
    return;
  }

  function blockedHere() {
    var path = location.pathname.replace(/\/+$/, '') || '/';
    return cfg.excludePaths.some(function (p) {
      p = (p || '').trim().replace(/\/+$/, '');
      return p && (path === p || path.indexOf(p + '/') === 0);
    });
  }
  function recentlyHandled() {
    var st = readState();
    if (!st) return false;
    if (st.state === 'done') return true;
    return st.state === 'closed' && Date.now() - st.at < cfg.hideDays * 864e5;
  }
  // Klaviyo already knows them (signed up before, came from an email): the old popup skipped them too.
  // First the __kla_id cookie (holds $email or $exchange_id once Klaviyo knows the visitor), then
  // klaviyo.isIdentified(). That call waits for cookie consent and may never answer, so it gets 3 seconds;
  // no answer means Klaviyo has no record of them here and the quiz opens.
  function knownToKlaviyo() {
    if (/[?&]_kx=/.test(location.search)) return Promise.resolve(true);
    var m = document.cookie.match(/(?:^|; )__kla_id=([^;]+)/);
    if (m) {
      try {
        var k = JSON.parse(atob(decodeURIComponent(m[1])));
        if (k.$email || k.$exchange_id) return Promise.resolve(true);
      } catch (e) { console.error('[coffee quiz] unreadable __kla_id cookie', e); }
    }
    if (!window.klaviyo || typeof window.klaviyo.isIdentified !== 'function') return Promise.resolve(false);
    return new Promise(function (resolve) {
      var t = setTimeout(function () { resolve(false); }, 3000);
      try {
        Promise.resolve(window.klaviyo.isIdentified()).then(function (v) { clearTimeout(t); resolve(!!v); }, function () { clearTimeout(t); resolve(false); });
      } catch (e) { clearTimeout(t); console.error('[coffee quiz] klaviyo.isIdentified', e); resolve(false); }
    });
  }

  // While a Klaviyo popup form is still published, never stack two popups: skip if one is on
  // screen, and step aside (without remembering a close) if Klaviyo opens one after ours.
  var klaviyoPopupOpen = false;
  window.addEventListener('klaviyoForms', function (e) {
    if (!e.detail || e.detail.type !== 'open') return;
    klaviyoPopupOpen = true;
    if (isOpen && !autoOpenedBy) return;
    if (isOpen) { isOpen = false; root.classList.remove('is-open'); document.body.classList.remove('ifq-lock'); root.hidden = true; }
  });
  function klaviyoPopupOnScreen() {
    return klaviyoPopupOpen || !!document.querySelector('.needsclick[role="dialog"][aria-label*="POPUP" i]');
  }
  var autoOpenedBy = false;

  if (blockedHere() || recentlyHandled()) return;
  var known = knownToKlaviyo(); // asked now, so the answer is in by the time the delay is up
  setTimeout(function () {
    known.then(function (isKnown) {
      if (isKnown || isOpen || recentlyHandled() || klaviyoPopupOnScreen()) return;
      open();
      autoOpenedBy = true;
    });
  }, cfg.delaySeconds * 1000);
})();
